import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../../utils/Loader";
import {
  get_dashboard_data_action,
} from "../../../actions/common_action/dashboard_action";
import { award_event_id, BASE_URL, responseError, toastError } from "../../../utils/constants";
import Pagination from "../../../utils/pagination";
import Header from "../../../common_components/Header";
import Footer from "../../../common_components/Footer";
import { Tab, Nav } from "react-bootstrap";
import moment from "moment";
import MobileHeader from "../../../common_components/mobileHeader";
import { Link } from "react-router-dom";
class applicantDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      user_id: "",
      role_id: "",
      Name: "",
      Description: "",
      is_active: "",
      applicantDashboardData: [],
      totalCount: [],
      filteredData: [],
      statusFillList: [],
      isAccordionExpanded: false,
      currentPage: 1,
      isTabOpen: '0',
      applicantDashboardList: [],
      circularData: [],
      application_no: '',
      dashboardStatusList: [],
      application_no: ''
    };
    this.getDashboardData = this.getDashboardData.bind(this);
    this.updateItem = this.updateItem.bind(this);
  }
  componentDidMount() {
    const tempData = localStorage.getItem("tempLoginData");

    if (tempData) {
      const userData = JSON.parse(tempData);
      sessionStorage.setItem("AwardsUserLoginData", JSON.stringify(userData));
      sessionStorage.setItem("loginAccesslist", JSON.stringify(userData["loginAccesslist"]));
      sessionStorage.setItem("user_id", userData["user_id"]);
      sessionStorage.setItem("email_address", userData["email_address"]);
      sessionStorage.setItem("user_name", userData["user_name"]);
      sessionStorage.setItem("role_id", userData["role_id"]);
      sessionStorage.setItem("jury_id", userData["jury_id"]);
      sessionStorage.setItem("accessToken", userData["accessToken"]);
      sessionStorage.setItem("refreshToken", userData["refreshToken"]);
      localStorage.removeItem("tempLoginData");
    }
    setTimeout(() => {
      this.setState({ isLoading: true });
      if (JSON.parse(sessionStorage.getItem("AwardsUserLoginData")) == null) {
        setTimeout(() => {
          this.props.navigate("/login");

        }, 500);
      }
      const sortUrl = BASE_URL.split("/api");
      this.setState({ downloadUrl: sortUrl[0] });
      setTimeout(() => {
        {
          sessionStorage.getItem("role_id") == 2 ? (
            this.props.navigate("/login")
          ) : (sessionStorage.getItem("role_id") == 1 || sessionStorage.getItem("role_id") == 3) ?
            this.props.navigate("/login") : <></>
        }
      }, 10);
      const { user_id } = this.state;
      this.setState({
        user_id:
          sessionStorage.getItem("user_id") == "" ||
            sessionStorage.getItem("user_id") == null
            ? ""
            : sessionStorage.getItem("user_id"),
        application_no: this.props.location.state != null && this.props.location.state.application_no
      });
      setTimeout(() => {
        this.getDashboardData();
      }, 500);
    }, 200);
  }

  getDashboardData = () => {
    const { application_no } = this.state;
    this.setState({ isLoading: true });
    this.props.get_dashboard_data_action(null, application_no != null && application_no != '' ? application_no : null)
      .then((data) => {
        if (data.error !== 1) {
          if (data.data[1] != '') {
            if (application_no != null && application_no != '') {
              this.setState({
                application_no: application_no,
                circularData: data?.data?.[3],
                currentpage: 1,
              }, () => this.getApplicationDashboardData(application_no));
            } else {
              this.setState({
                application_no: data?.data?.[1]?.[0]?.['application_no'],
                circularData: data?.data?.[3],
                currentpage: 1,
              }, () => this.getApplicationDashboardData(data?.data?.[1]?.[0]?.['application_no']));
            }

          }
          this.setState({ isLoading: false });
        } else {
          this.setState({ isLoading: false });
          if (data.msg == "Session expired! Please login again." || data.msg == "Token invalid") {
            //after session expire.....................
            sessionStorage.clear();
            this.props.navigate("/");
            setTimeout(() => {
              toastError(data.msg);
            }, 2000);
          } else {
            toastError(data.data);
          }
        }
      })
      .catch((e) => {
        console.log(e);
        this.setState({ isLoading: false });
      });
  }

  getApplicationDashboardData = (application_no) => {
    this.setState({ isLoading: true });
    this.props.get_dashboard_data_action(null, application_no)
      .then((data) => {
        if (data.error !== 1) {
          if (data.data != '') {
            this.setState({
              applicantDashboardList: data?.data?.[1],
              dashboardStatusList: data?.data?.[2],
            });
          }
          this.setState({ isLoading: false });
        } else {
          this.setState({ isLoading: false });
          responseError(data);
        }
      })
      .catch((e) => {
        console.log(e);
        this.setState({ isLoading: false });
      });
  }

  navigateApplicationStatus(award_event_profile_id, type) {
    this.props.navigate(`/adminApplicationList`, {
      state: { award_event_profile_id: award_event_profile_id, dashboardCountType: type },
    });
  }
  updateItem(item) {
    this.setState({ currentPage: item });
  }

  async navigateApplicationForm(award_event_profile_id, application_form_id) {
    // Navigate first
    await this.props.navigate('/applicationForm', {
      state: { award_event_profile_id, application_form_id }
    });

  }

  render() {
    const { isLoading, applicantDashboardList, circularData, downloadUrl, dashboardStatusList, application_no } = this.state;
    // Records to be displayed on the current page
    const userLoginData = JSON.parse(sessionStorage.getItem("AwardsUserLoginData"));
    const name = userLoginData ? userLoginData.user_name : '';

    const inCompleteArray = dashboardStatusList.filter(item => item.status_id == 1)
    const isCompletedStatusArray = dashboardStatusList.filter(item => item.status_id != 1)
    const winnerStatusArray = dashboardStatusList.filter(item => item.status_id == 9)

    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <>
          <main id="main">
            <div className="website-view">
              <Header data={[8]} />
            </div>
            <div className="mobile-view">
              <MobileHeader data={[8]} />
            </div>
            <section class='header_margin_top'>
              <div className="container-fluid">
                {/* <h4 className="dashboard-name py-2">Welcome {name}!</h4> */}
                {/* <div onClick={() => this.navigateRoleAdd()}>
                        <i class="ri-add-box-line" style={{fontSize:"28px",cursor:'pointer'}}></i>
                    </div> */}

                <div className="row mt-3">
                  <div className="col-md-8">
                    <h2 class="mb-3 dashboard-tit  py-0 blog-name">Dashboard</h2>
                    {applicantDashboardList?.length > 0 ?
                      // <Tab.Container defaultActiveKey={isTabOpen == "profile" ? "Profile" : isTabOpen == "application" ? "Application" : isTabOpen == "scoring" ? "Scoring" : "Profile"}>
                      <Tab.Container defaultActiveKey={applicantDashboardList?.findIndex(item => item.application_no === application_no) || '0'}
                      >
                        <Nav
                          variant="tabs"
                          className="nav nav-tabs nav-tabs-custom nav-success myOrderTabs application-nav-item"
                          role="tablist"
                        >
                          {applicantDashboardList?.map((data, i) => (
                            <Nav.Item>
                              <Nav.Link eventKey={i} onClick={() => this.getApplicationDashboardData(data.application_no)}>
                                {/* <i className="ri-store-2-fill me-1 align-bottom" />{" "} */}
                                {data.application_no}
                              </Nav.Link>
                            </Nav.Item>
                          ))}
                        </Nav>
                        {applicantDashboardList?.map((data, i) => (
                          <Tab.Content>
                            <Tab.Pane eventKey={i}>
                              {isCompletedStatusArray?.length > 0 && <>
                                <div className="timeline border" style={{ borderTopLeftRadius: '0px', borderTopRightRadius: '0px', borderTop: '0px' }}>
                                  {isCompletedStatusArray?.some(item => item.status_name === 'Draft') &&
                                    <div className="timeline-item">
                                      <div className="timeline-circle">
                                        <span>1</span>
                                        <span className="down-arrow-dashboard"><i class="ri-arrow-down-s-line"></i></span>
                                      </div>
                                      <div className="timeline-content">
                                        <h3 className="highlight mt-0" onClick={() => this.navigateApplicationForm(data.award_event_profile_id, isCompletedStatusArray[0]['application_form_id'])}>{isCompletedStatusArray[0]['status_name']}</h3>
                                        <p>
                                          <span className="datetime">
                                            Last Update
                                            <i class="ri-calendar-todo-fill"></i>{moment.utc(isCompletedStatusArray[0]['log_date']).format("DD/MM/YYYY")} {' '}
                                            <i class="ri-time-line"></i>
                                            {moment.utc(isCompletedStatusArray?.[0]?.['log_date']).format("hh:mm A")}
                                          </span>
                                        </p>
                                      </div>
                                    </div>
                                  }
                                  {(isCompletedStatusArray?.some(item => item.status_name === 'Submitted')) ?
                                    <div className="timeline-item">
                                      {/* <div className={!data.isIncomplete ? "timeline-circle" : "timeline-circle incomplete-timeline"}> */}
                                      <div className={"timeline-circle"}>
                                        <span>{isCompletedStatusArray?.some(item => item.status_name === 'Draft') ? 2 : 1}</span>
                                        <span className="down-arrow-dashboard"><i class="ri-arrow-down-s-line"></i></span>
                                      </div>
                                      {/* {!data.isIncomplete ? */}
                                      <div className="timeline-content">
                                        <h3 className="highlight" onClick={() => this.navigateApplicationForm(data.award_event_profile_id, isCompletedStatusArray?.[0]?.['application_form_id'])}

                                        >{isCompletedStatusArray?.some(item => item.status_name === 'Draft') ? isCompletedStatusArray?.[1]?.['status_name'] : isCompletedStatusArray?.[0]?.['status_name']}{data.isIncomplete ?
                                          <a className="text-danger" title={inCompleteArray?.length > 0 && `Incompleted on ${moment.utc(inCompleteArray?.[0]?.['log_date']).format("DD/MM/YYYY") + ' ' + moment.utc(inCompleteArray?.[0]?.['log_date']).format("hh:mm A") + ' : ' + inCompleteArray[0]['remark']}`}>{' '}(!)</a> : ''} </h3>
                                        <p>
                                          <span className="datetime">
                                            Submitted on  {isCompletedStatusArray?.some(item => item.status_name === 'Draft') ?
                                              <>
                                                <i class="ri-calendar-todo-fill"></i>{moment.utc(isCompletedStatusArray?.[1]?.['log_date']).format("DD/MM/YYYY")} {' '}
                                                <i class="ri-time-line"></i>
                                                {moment.utc(isCompletedStatusArray?.[1]?.['log_date']).format("hh:mm A")}
                                              </>
                                              :
                                              <>
                                                <i class="ri-calendar-todo-fill"></i>{moment.utc(isCompletedStatusArray[0]['log_date']).format("DD/MM/YYYY")} {' '}
                                                <i class="ri-time-line"></i>
                                                {moment.utc(isCompletedStatusArray?.[0]?.['log_date']).format("hh:mm A")}
                                              </>
                                            }
                                          </span>
                                        </p>
                                      </div>
                                      {/* :
                                          <div className="timeline-content">
                                            <h3 className="highlight" onClick={() => this.navigateApplicationForm(data.award_event_profile_id, isCompletedStatusArray[0]['application_form_id'])}>Incomplete</h3>
                                            <p>
                                              <span className="datetime">
                                                Last Update {inCompleteArray.length > 0 && <span className="datetime">
                                                  <i class="ri-calendar-todo-fill"></i>{moment.utc(inCompleteArray[0]['log_date']).format("DD/MM/YYYY")} {' '}
                                                  <i class="ri-time-line"></i>
                                                  {moment.utc(inCompleteArray[0]['log_date']).format("hh:mm A")}
                                                </span>}
                                              </span>
                                            </p>
                                          </div> */}

                                      {/* } */}
                                    </div> :
                                    <div className="timeline-item">
                                      <div className="timeline-circle timeline-circle-disable">
                                        <span>{isCompletedStatusArray?.some(item => item.status_name === 'Draft') ? 2 : 1}</span>
                                        <span className="down-arrow-dashboard"><i class="ri-arrow-down-s-line"></i></span>
                                      </div>
                                      <div className="timeline-content">
                                        <h3 className="highlight highlight-disable" onClick={() => this.navigateApplicationForm(data.award_event_profile_id, isCompletedStatusArray[0]['application_form_id'])}>Submitted on</h3>
                                        <p>
                                          <span className="datetime">
                                            -
                                          </span>
                                        </p>
                                      </div>
                                    </div>
                                  }
                                  {isCompletedStatusArray?.some(item => item.status_name === 'Rejected') || isCompletedStatusArray.some(item => item.status_name === 'Verified') ?
                                    <div className="timeline-item">
                                      <div className={
                                        isCompletedStatusArray?.some(item => item.status_name === 'Draft') ? (isCompletedStatusArray[2]['status_name'] == 'Rejected' ? "timeline-circle  reject-timeline" : "timeline-circle") : (isCompletedStatusArray?.[1]?.['status_name'] == 'Rejected' ? "timeline-circle reject-timeline" : "timeline-circle")
                                      }>
                                        <span>{isCompletedStatusArray?.some(item => item.status_name === 'Draft') ? 3 : 2}</span>
                                        <span className="down-arrow-dashboard"><i class="ri-arrow-down-s-line"></i></span>
                                      </div>
                                      <div className="timeline-content">
                                        <h3 className={
                                          isCompletedStatusArray?.some(item => item.status_name === 'Draft') ? (isCompletedStatusArray[2]['status_name'] == 'Rejected' ? "reject-highlight" : "highlight") : (isCompletedStatusArray?.[1]?.['status_name'] == 'Rejected' ? "reject-highlight" : "highlight")

                                        } onClick={() => this.navigateApplicationForm(data.award_event_profile_id, isCompletedStatusArray[0]['application_form_id'])}>{isCompletedStatusArray?.some(item => item.status_name === 'Draft') ? isCompletedStatusArray?.[2]?.['status_name'] : isCompletedStatusArray[1]['status_name']}</h3>
                                        <p>
                                          <span className="datetime">
                                            {isCompletedStatusArray?.some(item => item.status_name === 'Draft') ?
                                              <>
                                                {isCompletedStatusArray?.[2]?.status_name}  on <i class="ri-calendar-todo-fill"></i>{moment.utc(isCompletedStatusArray?.[2]?.['log_date']).format("DD/MM/YYYY")} {' '}
                                                <i class="ri-time-line"></i>
                                                {moment.utc(isCompletedStatusArray?.[2]?.['log_date']).format("hh:mm A")}
                                              </> :
                                              <>
                                                {isCompletedStatusArray?.[1]?.status_name} on <i class="ri-calendar-todo-fill"></i>{moment.utc(isCompletedStatusArray?.[1]?.['log_date']).format("DD/MM/YYYY")} {' '}
                                                <i class="ri-time-line"></i>
                                                {moment.utc(isCompletedStatusArray?.[1]?.['log_date']).format("hh:mm A")}
                                              </>
                                            }
                                          </span>
                                        </p>
                                      </div>
                                    </div> :
                                    <div className="timeline-item">
                                      <div className="timeline-circle timeline-circle-disable">
                                        <span>{isCompletedStatusArray?.some(item => item.status_name === 'Draft') ? 3 : 2}</span>
                                        <span className="down-arrow-dashboard"><i class="ri-arrow-down-s-line"></i></span>
                                      </div>
                                      <div className="timeline-content">
                                        <h3 className="highlight highlight-disable" onClick={() => this.navigateApplicationForm(data.award_event_profile_id, isCompletedStatusArray[0]['application_form_id'])}>Verified / Rejected</h3>
                                        <p>
                                          <span className="datetime">
                                            -
                                          </span>
                                        </p>
                                      </div>
                                    </div>
                                  }
                                  {isCompletedStatusArray?.some(item => item.status_name === 'Reviewed') ?
                                    <div className="timeline-item">
                                      <div className="timeline-circle ">
                                        <span>{isCompletedStatusArray?.some(item => item.status_name === 'Draft') ? 4 : 3}</span>
                                        <span className="down-arrow-dashboard"><i class="ri-arrow-down-s-line"></i></span>
                                      </div>
                                      <div className="timeline-content">
                                        <h3 className="highlight" onClick={() => this.navigateApplicationForm(data.award_event_profile_id, isCompletedStatusArray?.[0]?.['application_form_id'])}>{isCompletedStatusArray?.some(item => item.status_name === 'Draft') ? isCompletedStatusArray[3]['status_name'] : isCompletedStatusArray[2]['status_name']}</h3>
                                        <p>
                                          <span className="datetime">
                                            {isCompletedStatusArray?.some(item => item.status_name === 'Draft') ?
                                              <>
                                                Reviewed on <i class="ri-calendar-todo-fill"></i>{moment.utc(isCompletedStatusArray?.[3]?.['log_date']).format("DD/MM/YYYY")} {' '}
                                                <i class="ri-time-line"></i>
                                                {moment.utc(isCompletedStatusArray?.[3]?.['log_date']).format("hh:mm A")}
                                              </>
                                              :
                                              <>
                                                Reviewed on <i class="ri-calendar-todo-fill"></i>{moment.utc(isCompletedStatusArray?.[2]?.['log_date']).format("DD/MM/YYYY")} {' '}
                                                <i class="ri-time-line"></i>
                                                {moment.utc(isCompletedStatusArray?.[2]?.['log_date']).format("hh:mm A")}
                                              </>
                                            }
                                          </span>
                                        </p>
                                      </div>
                                    </div> :
                                    <div className="timeline-item">
                                      <div className="timeline-circle timeline-circle-disable">
                                        <span>{isCompletedStatusArray.some(item => item.status_name === 'Draft') ? isCompletedStatusArray.some(item => item.status_name === 'Partial Reviewed') ? 5 : 4 : 3}</span>
                                        <span className="down-arrow-dashboard"><i class="ri-arrow-down-s-line"></i></span>
                                      </div>
                                      <div className="timeline-content">
                                        <h3 className="highlight highlight-disable" >Reviewed</h3>
                                        <p>
                                          <span className="datetime">
                                            -
                                          </span>
                                        </p>
                                      </div>
                                    </div>
                                  }
                                  {isCompletedStatusArray.some(item => item.status_name === 'Reviewed') && data.milestone_status == 'result declare' ?
                                    <div className="timeline-item">
                                      <div className="timeline-circle ">
                                        <span>{isCompletedStatusArray.some(item => item.status_name === 'Draft') ? 5 : 6}</span>
                                      </div>
                                      <div className="timeline-content mt-4">
                                        <h3 className="highlight" onClick={() => this.navigateApplicationForm(data.award_event_profile_id, isCompletedStatusArray?.[0]?.['application_form_id'])}>Result Declared</h3>
                                        {/* <p>
                                            <span className="datetime">
                                              Result Declared on<i class="ri-calendar-todo-fill"></i>{moment.utc(winnerStatusArray[0]['log_date']).format("DD/MM/YYYY")} {' '}
                                              <i class="ri-time-line"></i>
                                              {moment.utc(winnerStatusArray[0]['log_date']).format("hh:mm A")}
                                            </span>
                                          </p> */}
                                      </div>
                                    </div> :
                                    <div className="timeline-item">
                                      <div className="timeline-circle timeline-circle-disable">
                                        <span>{isCompletedStatusArray?.some(item => item.status_name === 'Draft') ? 5 : 4}</span>
                                      </div>
                                      <div className="timeline-content">
                                        <h3 className="highlight highlight-disable" >Result Declared</h3>
                                        <p>
                                          <span className="datetime">
                                            -
                                          </span>
                                        </p>
                                      </div>
                                    </div>
                                  }
                                </div>
                              </>}
                            </Tab.Pane>

                          </Tab.Content>
                        ))}
                      </Tab.Container>

                      :
                      // <div className="aside-group border-bottom">
                      //   <ul className="p-0 m-0">
                      //     <li className="tit-date"> </li>
                      //     <li className="tit-name"> <b>No Application Found</b></li>
                      //     <li className="tit-date pb-2"></li>
                      //   </ul>
                      // </div>

                      <div className="partner-button website">
                        <Link to="/">
                          <a className="btn">
                            Apply for Awards{" "}
                            <i className="fa fa-angle-double-right" />
                          </a>
                        </Link>
                      </div>
                    }
                  </div>
                  <div className="col-md-4">
                    <h2 class="mb-3 dashboard-tit  py-0 blog-name">Circular</h2>
                    <div className={circularData?.length > 0 ? "circular border" : ''}>
                      {circularData?.length > 0 ? circularData?.map((data, i) => (
                        data.circular_id ? <>
                          <div className="aside-group border-bottom mb-2">
                            <ul className="p-0 m-0">
                              <li className="d-flex justify-content-between align-items-center">
                                <span className="tit-name" style={{ maxWidth: '80%', overflow: 'hidden', wordWrap: 'break-word', whiteSpace: 'normal' }}>
                                  <b>{data.title}</b>
                                </span>
                                <span className="tit-date">{moment(data.circular_date).format("DD-MM-YYYY")}</span>
                              </li>
                              <li className="tit-date pb-2" style={{ maxWidth: '80%', overflow: 'hidden', wordWrap: 'break-word', whiteSpace: 'normal' }}>{data.content}</li>
                              <li className="tit-date pb-2 membership_file">
                                <a href={`${downloadUrl + data.file_path}`} target="_blank" rel="noopener noreferrer">
                                  {data.file_path?.split('/').pop()}
                                </a>
                              </li>
                            </ul>
                          </div>
                        </> : <></>
                      )) : (
                        <div className="aside-group border-bottom">
                          <ul className="p-0 m-0">
                            <li className="tit-date"> </li>
                            <li className="tit-name"> <b>No Circular Released</b></li>
                            <li className="tit-date pb-2"></li>
                          </ul>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="custom_table">
                  <div className="hack1">
                    <div className="hack2">

                    </div>
                  </div>
                </div>
              </div>
            </section>
          </main>

          <Footer />
          <ToastContainer />
        </>
      </>
    );
  }
}
export default withRouter(
  connect(null, { get_dashboard_data_action })(applicantDashboard)
);
